/**
 * @generated SignedSource<<2535b2c8c8fcd0d4e624a7399b49f3a9>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export interface AddPublicLinkPermissionsInput {
  objectId: Scalars["ID"]["input"];
  objectType: PublicLinkPermissionsObjectType;
  permissions: Array<PublicLinkPermissionsType>;
}
export enum PublicLinkPermissionsObjectType {
  CONTENT = "CONTENT",
}
export enum PublicLinkPermissionsType {
  EDIT = "EDIT",
}
export type useAddPublicLinkPermissionsMutationAddPublicLinkPermissionsMutation_addPublicLinkPermissions_AddPublicLinkPermissionsPayload_errors_MutationError =
  {
    __typename?: "MutationError";
    message: string | null;
  };
export type useAddPublicLinkPermissionsMutationAddPublicLinkPermissionsMutation_addPublicLinkPermissions_AddPublicLinkPermissionsPayload =
  {
    __typename?: "AddPublicLinkPermissionsPayload";
    success: boolean;
    errors: Array<useAddPublicLinkPermissionsMutationAddPublicLinkPermissionsMutation_addPublicLinkPermissions_AddPublicLinkPermissionsPayload_errors_MutationError> | null;
  };
export type useAddPublicLinkPermissionsMutationAddPublicLinkPermissionsMutation_Mutation =
  {
    __typename?: "Mutation";
    addPublicLinkPermissions: useAddPublicLinkPermissionsMutationAddPublicLinkPermissionsMutation_addPublicLinkPermissions_AddPublicLinkPermissionsPayload;
  };
export type useAddPublicLinkPermissionsMutationAddPublicLinkPermissionsMutationVariables =
  Exact<{
    addPublicLinkPermissionsInput: AddPublicLinkPermissionsInput;
  }>;
export type useAddPublicLinkPermissionsMutationAddPublicLinkPermissionsMutation =
  useAddPublicLinkPermissionsMutationAddPublicLinkPermissionsMutation_Mutation;
